import { Card } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';

import Modal from '@/components/Modal';
import AddPaymentMethod from '@/components/Profile/Billing/AddPaymentMetod';
import PaymentMethodCard from '@/components/Profile/Billing/PaymentMethodCard';
import {
  useMakeDefaultMethod,
  useSelectedPaymentMethod,
} from '@/Utils/stripeHooks/usePaymentMethods';
import AvailableBalance from '@/components/Operator/Stripe/AvailableBalance';

type PaymentMethods = {
  method: string;
  defaultPaymentMethodId: string;
  paymentMethods?: Card[];
  isBooking?: boolean;
  handleSelectedPayment: (id: string) => void;
};
const PaymentMethods = ({ paymentMethods, stripeKey, isBooking }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleToggleModal = () => {
    setIsOpen((prev) => !prev);
  };
  const defaultMethod = useMakeDefaultMethod();
  const { selected, setSelected, handleSelectedPayment } =
    useSelectedPaymentMethod();
  useEffect(() => {
    if (!paymentMethods || paymentMethods.length === 0) return;

    const hasDefaultMethod = paymentMethods.some((method) => method.default);

    if (!hasDefaultMethod && !defaultMethod.isLoading) {
      defaultMethod.mutate(paymentMethods[0].id);
    }
  }, [paymentMethods]);

  const sortedPaymentMethods = paymentMethods?.sort((a, b) =>
    a.default ? -1 : b.default ? 1 : 0,
  );

  const isLastPayMethod = paymentMethods?.length <= 1;
  return (
    <>
      <h3 className='form-title mt-16'>Payment Method(s)</h3>
      {isBooking && <AvailableBalance />}
      <div className='flex flex-col gap-5'>
        {sortedPaymentMethods?.length > 0 &&
          sortedPaymentMethods.map((method) => (
            <PaymentMethodCard
              method={method}
              key={method.id}
              isLastPayMethod={isLastPayMethod}
              isBooking={isBooking}
              setSelected={setSelected}
              selected={selected}
              handleSelectedPayment={handleSelectedPayment}
            />
          ))}
        <button
          onClick={handleToggleModal}
          className='w-full bg-transparent p-8 border-dashed border-customGrey text-customBlue text-center box-border rounded-lg cursor-pointer dashed'
          type='button'
        >
          + Add Payment Method
        </button>
        {        
        isBooking && <p className='text-14px text-textGrey'>By providing your card information, you allow EvoLux Transportation, LLC to charge your card for future payments in accordance with their terms.</p>
        }      
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleToggleModal}
        shouldCloseOnOverlayClick={true}
        additionalStyles={{ maxWidth: '494px' }}
      >
        <AddPaymentMethod
          stripeKey={stripeKey}
          handleToggleModal={handleToggleModal}
          handleSelectedPayment={handleSelectedPayment}
        />
      </Modal>
    </>
  );
};
export default PaymentMethods;
